import React from 'react'
import PropTypes from 'prop-types'

export const MessagesCount = ({ count, size, className }) => (
  <div style={{ width: size, height: size }} className={className('messages-count')}>
    <span style={{ width: size, height: size }} className={className('messages-count-number')}>
      {count}
    </span>
  </div>
)

MessagesCount.propTypes = {
  count: PropTypes.number.isRequired,
  size: PropTypes.number,
  className: PropTypes.func.isRequired,
}

MessagesCount.defaultProps = {
  size: 20,
  width: 20,
}

export default MessagesCount
